import { useEffect, useState } from 'react';

import { getStartOfDay } from '@/shared/lib/time-utils';

// Re-arms relative to `Date.now()` on every fire (not a fixed interval), so the page keeps naming
// the right day even if the tab was backgrounded or the system clock jumped.
export function useToday(): Date {
    const [today, setToday] = useState(() => getStartOfDay(new Date()));

    useEffect(() => {
        // Past a month's last day, `getDate() + 1` rolls into the next month.
        const nextMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        const msUntilMidnight = nextMidnight.getTime() - Date.now();
        const timeoutId = setTimeout(() => setToday(getStartOfDay(new Date())), msUntilMidnight);
        return () => clearTimeout(timeoutId);
    }, [today]);

    return today;
}
